import { is } from "./is";
import { show } from "./show";
import { showType } from "./show-type";
import {
  TypeKey,
  UnionCase,
  KindKey,
  UnionCases,
  UnionValues,
  UnionType
} from "../symbols";

export const Union = (name, spec) => {
  const specKeys = Object.keys(spec);

  return specKeys.reduce(
    (acc, key) => {
      const _case = (...vals) => {
        const hasErrors = spec[key].some((type, i) => !is(vals[i], type));

        if (hasErrors) {
          throw new TypeError(`
Type mismatch: Type ${name}.${key}(${spec[key]
            .map(showType)
            .join(
              ", "
            )}) was invoked with incompatible types: ${name}.${key}(${vals
            .map(show)
            .join(", ")})
`);
        }

        return {
          [TypeKey]: name,
          [UnionCase]: key,
          [KindKey]: UnionType,
          [UnionCases]: specKeys,
          [UnionValues]: vals
        };
      };

      _case[TypeKey] = name;
      _case[KindKey] = UnionType;
      _case[UnionCase] = key;

      return { ...acc, [key]: _case };
    },
    { [TypeKey]: name, [UnionCases]: specKeys, [KindKey]: UnionType }
  );
};

export const caseOf = (type, spec) => {
  if (type[KindKey] !== UnionType) {
    throw new TypeError(
      `'match' expects a union type but was called with ${show(type)}`
    );
  }

  const wildCard = spec._;
  const specKeys = Object.keys(spec);

  if (
    !wildCard &&
    !type[UnionCases].every(key => specKeys.some(_case => key === _case))
  ) {
    throw new TypeError(`Non-exhaustive pattern matching detected, expected: ${show(
      type[UnionCases]
    )} but got: ${show(specKeys)}.
Please provide all cases or use a wildcard.`);
  }

  const match = spec[type[UnionCase]] || wildCard;
  return match(...type[UnionValues]);
};
